export default "__VITE_ASSET__tFROq_UU__"